import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiLoaderCircle } from "react-icons/bi";
import moment from "moment";
import toast from "react-hot-toast";

import { LoadUserData, LoadUserBillingData, CancelSubscription, CheckRequirementsAndRedirectV2 } from "../../../../redux/v2/user/actions";

import CustomButton from "../../../../common/CustomButton";
import CancelMainPage from "./Components/CancelMainPage";
import WaitUp from "./Components/WaitUp";

import "./style.css";

function CancelSubscriptionForm(props) {
    const navigate = useNavigate();

    const { account } = props.User;
    const billing = account?.billingInfo;

    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        const requirementStatus = localStorage.getItem("requirement_status");
        const res = await props.CheckRequirementsAndRedirectV2(navigate);

        // if (requirementStatus == 3 || requirementStatus == "null") {
        //     if (!billing.id) {
        //         props.LoadUserData();
        //         props.LoadUserBillingData();
        //     }
        // }
    }, []);

    const [isCancelForm, setIsCancelForm] = useState(true);
    const [isCancelled, setIsCancelled] = useState(false);

    const [selectedReason, setSelectedReason] = useState("");
    const [otherReason, setOtherReason] = useState("");

    const [currentButton, setCurrentButton] = useState(0);

    const complete = (selectedReason != "Others" && selectedReason != "") || (selectedReason == "Others" && otherReason != "");
    const buttons = [
        <div
            className={`cancelButton ${!complete ? "disabled" : ""}`}
            onClick={() => {
                if (complete) {
                    setCurrentButton(1);
                    setIsCancelForm(false);
                }
            }}
        >
            <p>SUBMIT</p>
        </div>,

        <div
            className={`cancelButton`}
            onClick={async () => {
                setCurrentButton(2);

                const res = await props.CancelSubscription({
                    recurly: account?.subscription?.recurly_acc_id,
                    subscriptionID: account?.subscription?.subscription_id,
                    reason: selectedReason != "Others" ? selectedReason : otherReason,
                });

                if (res.success) {
                    toast.success("Cancelled Successfully");
                    setIsCancelled(true);
                    setCurrentButton(0);
                } else {
                    toast.error("Failed to cancel");
                    setCurrentButton(0);
                }
            }}
        >
            <p>CANCEL</p>
        </div>,

        // <CustomButton
        //     onClick={async () => {

        //     }}
        // >
        //     CONFIRM?
        // </CustomButton>,

        <div>
            <BiLoaderCircle className="btn-loading" style={{ margin: "0" }} />
        </div>,

        <CustomButton>SAVED!</CustomButton>,
    ];

    return (
        <>
            <div className="container-v2" id="cancel-membership-page" style={{ paddingTop: "30px" }}>
                {!isCancelled ? (
                    isCancelForm ? (
                        <div className="flex-c">
                            {" "}
                            {/* PRE CANCEL */}
                            <CancelMainPage setSelectedReason={setSelectedReason} selectedReason={selectedReason} setOtherReason={setOtherReason} button={buttons[currentButton]} />
                        </div>
                    ) : (
                        <div className="flex-c">
                            <WaitUp button={buttons[currentButton]} billing={billing} />
                        </div>
                    )
                ) : (
                    <div>
                        <div className="cmp-header cancelled-div" style={{ marginTop: "100px" }}>
                            <p style={{ paddingBottom: "15px" }}>Subscription Cancelled</p>

                            <div className="cmp-subheader">
                                <div>
                                    <p>You will continue to have access to your workouts, stats, and challenges until {moment(new Date(billing.currentPeriodEndsAt)).format("LL")}. To resubscribe, visit billing in your indi profile.</p>
                                </div>
                            </div>
                            <div className="cmp-footer">
                                <CustomButton
                                    className="active"
                                    onClick={() => {
                                        navigate("/");
                                        setIsCancelForm(false);
                                        setIsCancelled(false);
                                        props.LoadUserBillingData();
                                    }}
                                >
                                    Return to indi
                                </CustomButton>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    LoadUserData,
    LoadUserBillingData,
    CancelSubscription,
    CheckRequirementsAndRedirectV2,
})(CancelSubscriptionForm);
